import { render, staticRenderFns } from "./PuzzleBoard.vue?vue&type=template&id=5e8a434a&"
import script from "./PuzzleBoard.vue?vue&type=script&lang=js&"
export * from "./PuzzleBoard.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports